import dayjs, {Dayjs} from "dayjs";

export class StatusUtils {
    // Status translations
    static statusTranslations: Record<'DONE' | 'READY' | 'NOT_READY' | 'PENDING', string> = {
        DONE: 'Abgeschlossen',
        READY: 'Bereit',
        NOT_READY: 'Nicht Bereit',
        PENDING: 'In Arbeit',
    };

    // Status color mapping
    static colorMap: Record<'NOT_READY' | 'READY' | 'PENDING' | 'DONE', string> = {
        NOT_READY: 'darkred',       // Bright red for "Not Ready"
        READY: 'darkgreen',         // Bold green for "Ready"
        PENDING: 'goldenrod',       // Gold for "In Progress"
        DONE: 'darkgrey',            // Navy blue for "Done"
    };

    // Utility to get translated status
    static getTranslatedStatus(status: 'DONE' | 'READY' | 'NOT_READY' | 'PENDING'): string {
        return this.statusTranslations[status] || status;
    }

    // Utility to get color for a status
    static getColor(status: 'DONE' | 'READY' | 'NOT_READY' | 'PENDING'): string {
        return this.colorMap[status] || 'default';
    }

    static calculateWorkingHours = (startDate: Dayjs, endDate: Dayjs): number => {
        let date = startDate.startOf('day');
        let workingHours = 0;
        while (date.isBefore(endDate, 'day')) {
            date = date.add(1, 'day');
            if (date.day() !== 0 && date.day() !== 6) {
                // Add 8 hours for each working day
                workingHours += 8;
            }
        }
        return workingHours;
    };

    static calculateWorkingDays = (daysToAdd: number): Dayjs => {
        let date = dayjs();
        let addedDays = 0;

        while (addedDays < daysToAdd) {
            date = date.add(1, 'day');
            // Skip Saturdays (6) and Sundays (0)
            if (date.day() !== 0 && date.day() !== 6) {
                addedDays++;
            }
        }
        return date;
    };

}
